<template>
  <VAutocomplete
    v-model="model"
    class="df-autocomplete"
    :label="schema.label"
    :allow-overflow="false"
    :hint="schema.hint"
    :item-text="schema.itemText"
    :item-value="schema.itemValue"
    :items="schema.items"
    :placeholder="schema.placeholder"
    :rules="rules"
  >
    <template v-slot:append>
      <NsIcon icon-name="icon-chevron-down" height="20" width="20" />
    </template>
  </VAutocomplete>
</template>

<script>
/**
 * Original Author: Aaron Turnblom
 * Original Team: Area 51
 */
import { VAutocomplete } from 'vuetify/lib';
import { NsIcon } from '@nuskin/ns-icon';

import { PropsMixin, RulesMixin, ModelMixin } from '../mixins';

export default {
  name: 'DfAutocompleteField',
  components: {
    NsIcon,
    VAutocomplete,
  },
  mixins: [PropsMixin, RulesMixin, ModelMixin({ deep: true })],
  props: {
    /**
     * Field value
     * @type {Object}
     */
    value: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="scss" scoped>
@use "sass:map";
@use "~@nuskin/ns-core-styles/src/scss/_typographyVariables.scss" as types;
::v-deep {
  font-family: map.get(types.$typography, 'font-family-primary');
  .v-label {
    line-height: 22px;
    transform: none !important;
    animation: none !important;
  }
  .v-select__slot {
    align-items: flex-start !important;
  }
}
</style>
